import ExcelJS from "exceljs";
import { useTranslation } from "react-i18next";
import { useRebarProjectInfoStore } from "../../stores/rebarProjectInfoStore";
import { addWatermarkImage } from "./utilFunctions";
import { saveAs } from "file-saver";

export default function useExportProject() {
    const { t } = useTranslation();
    const projectName = useRebarProjectInfoStore(
        (state) => state.projectName
    );
    const rebars = useRebarProjectInfoStore((state) => state.rebars);

    const workbook = new ExcelJS.Workbook();

    const rebarsSheet = () => {
        const worksheet = workbook.addWorksheet(t("Donatılar"));

        const columnWidths = [15, 15, 20, 20, 10, 10, 20, 20, 20];
        const totalCols = columnWidths.length;

        columnWidths.forEach((width, i) => {
            worksheet.getColumn(i + 1).width = width;
        });

        addWatermarkImage(workbook, worksheet, totalCols);

        // Set headers in row 2
        const headers = [
            t("Donatı Kodu"),
            t("Adet"),
            `${t("Uzunluk")} (cm)`,
            `${t("Çap")} (mm)`,
            t("Poz"),
            t("Kat"),
            t("Yapı Elemanı"),
            t("Eleman Kodu"),
            t("Açıklama"),
        ];

        headers.forEach((header, colIndex) => {
            const cell = worksheet.getCell(2, colIndex + 1);
            cell.value = header;
            cell.font = { bold: true };
            cell.alignment = { horizontal: "center" };
        });

        rebars.forEach((rebar, index) => {
            const row = worksheet.getRow(3 + index);
            row.values = [
                rebar.code,
                rebar.number,
                rebar['length'],
                rebar.diameter,
                rebar.poz,
                rebar.floor,
                rebar.element,
                rebar.elementCode,
                rebar.explanation,
            ];
        });
    }

    const clearWorkbook = () => {
        workbook.removeWorksheet("Donatılar");
    }

    const exportProject = () => {
        rebarsSheet();

        const fileName = `${projectName}_${new Date().toISOString().replace(/[:.-]/g, "")}.xlsx`;

        workbook.xlsx.writeBuffer().then((data) => {
            const blob = new Blob([data], { type: "application/octet-stream" });
            saveAs(blob, fileName);
        });

        clearWorkbook();
    }

    return { exportProject };
}